import React, { useRef } from "react";
import "./becomeEducator.css";
import { Box } from "@mui/system";
import { Button, Typography, useMediaQuery, useTheme } from "@mui/material";
import MoneyIcon from "../../Assets/Images/moneyIcon.png";
import SharingIcon from "../../Assets/Images/sharingIcon.png";
import TeachIcon from "../../Assets/Images/teachIcon.png";
import becomeimg from "../../Assets/Images/becomeEducatorBgImg.png";
import { useLocation, useNavigate } from "react-router-dom";
import Grid from "@mui/material/Unstable_Grid2";
import { useSelector } from "react-redux";
import { styles } from "./styles";
import Auth from "../../Views/Common/AuthModals/authModals";
import DialogBox from "../Common/DialogBox/dialogBox";
import { Loader } from "../Common/Loader/loader";
import { auth } from "../../Infrastructure/config";
import EducatorFaq from "../Faq/educatorFaq";
import paths from "../../Infrastructure/Router/paths";

const BecomeEducator = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const sectionRef = useRef(null);
  const uid = auth?.currentUser?.uid;
  const [open, setOpen] = React.useState(false);
  const message = "Educator Onboarding Complete";
  const isDesktop = useMediaQuery(theme.breakpoints.up("sm"));
  const userData = useSelector((state) => state.userData.data);
  const loading = useSelector((state) => state.userData.loading);
  const onboardingComplete = userData?.educator?.onboarding_complete;
  const chooseModal = useSelector((state) => state.auth.chooseModal);
  const is_educator = userData?.is_educator

  const navigateToBecomeEdu = async () => {
    if (!uid) {
      navigate(paths.onboardingPage.path, { state: { from: location.pathname } });
    }
    if (is_educator) {
      if (onboardingComplete) {
        setOpen(true);
      } else {
        navigate(paths.onboardingPage.path, { state: { from: location.pathname } });
      }
    } else {
      setOpen(true);
    }
  };
  const scrollToSection = () => {
    sectionRef.current.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <>
      {loading ? (
        <Box height={'100vh'}>
          <Loader />
        </Box>
      ) : (
        <>
          {/* Section 1 */}
          <DialogBox open={open} setOpen={setOpen} message={is_educator ? message : "Must have Educator Account"} />
          <Auth chooseModal={chooseModal} />
          <div className={isDesktop ? "bg-img" : "bg-img2"}>
            <Grid container lg={6} sx={styles.Sec1MainGrid}>
              <Grid>
                <Typography align="center" sx={styles.boxTypo}>
                  Teach Live Classes Online
                </Typography>
                <Typography align="center" sx={styles.boxContent}>
                  Become an Educator on the Vulcan Platform. Enrich lives. Earn
                  income.
                </Typography>
              </Grid>
              <Grid
                sx={styles.buttonGridSx}
                lg={12}
                md={12}
                sm={12}
                xs={12}
              >
                <Button
                  variant="contained"
                  size="small"
                  onClick={navigateToBecomeEdu}
                  sx={styles.textCapitalize}
                >
                  Get Started
                </Button>
                <Button
                  onClick={scrollToSection}
                  variant="contained"
                  size="small"
                  sx={styles.textCapitalize}
                >
                  Learn More
                </Button>
              </Grid>
            </Grid>
          </div>
          <Box>
            {!isDesktop && <img src={becomeimg} width={"100%"} alt="" />}
          </Box>
          {/* Section 2 */}
          <Box ref={sectionRef} sx={styles.Sec2Box}>
            <Box sx={styles.Sec2BoxTitle}>
              <Typography sx={styles.Sec2Typo}>
                Why teach on the Vulcan Learning platform?
              </Typography>
            </Box>
            <Grid
              container
              sx={styles.containerGridSx}
            >
              <Grid
                xs={12}
                md={4}
                sx={styles.subGridSx}
              >
                <Box sx={styles.subGridImgBox}>
                  <img src={MoneyIcon} alt="dollar" />
                </Box>
                <Typography sx={styles.subgridTypoHeading}>
                  Monetize Your Knowledge
                </Typography>
                <Box sx={styles.descriptionBoxSx}>
                  <Typography sx={styles.subgridTypoDescription}>
                    Generate consistent and unbounded income. Part time or Full
                    time. On the Vulcan Learning platform you keep 100% of what
                    you earn.
                  </Typography>
                </Box>
              </Grid>
              <Grid
                lg={4}
                sm={12}
                md={4}
                xs={12}
                sx={styles.subGridSx}
                marginTop={isDesktop ? "0px" : "40px"}
              >
                <Box sx={styles.subGridImgBox}>
                  <img src={SharingIcon} alt="" />
                </Box>
                <Typography sx={styles.subgridTypoHeading}>
                  Change Lives
                </Typography>
                <Box sx={styles.descriptionBoxSx2}>
                  <Typography sx={styles.subgridTypoDescription}>
                    {" "}
                    Share your experience and help learners explore their
                    interests, gain new skills, and advance their careers.
                  </Typography>
                </Box>
              </Grid>
              <Grid
                lg={4}
                sm={12}
                md={4}
                xs={12}
                sx={styles.subGridSx}
                marginTop={isDesktop ? "0px" : "40px"}
              >
                <Box sx={styles.subGridImgBox}>
                  <img src={TeachIcon} alt="" />
                </Box>
                <Typography sx={styles.subgridTypoHeading}>
                  You are in control
                </Typography>
                <Box sx={styles.descriptionBoxSx2}>
                  <Typography sx={styles.subgridTypoDescription}>
                    Set the course curriculum, choose the class schedule, and
                    devise the teaching strategies that work best for you.
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Box>
          <Box sx={styles.faqBoxSx}>
            <EducatorFaq/>
          </Box>
        </>
      )}
    </>
  );
};

export default BecomeEducator;
